<div class="eventq-browser-tab-bar" [class.eventq-browser-tab-bar--popout]="popoutMode()">
  <div
    #tabsScroll
    class="eventq-browser-tab-bar__tabs"
    role="tablist"
    (wheel)="onTabsWheel($event)"
    (pointerleave)="onTabHover(null)"
  >
    @for (tab of tabs(); track tab.id) {
      <eventq-browser-tab
        [tabId]="tab.id"
        [label]="tab.label"
        [tags]="tab.tags ?? []"
        [runtimeLabel]="tab.runtimeLabel ?? null"
        [active]="tab.id === activeTabId()"
        [expanded]="expanded() && tab.id === activeTabId()"
        [hovered]="hoveredTabId() === tab.id"
        [popoutMode]="popoutMode()"
        [expandEnabled]="expandEnabled()"
        [closeEnabled]="closeableTabIds().includes(tab.id)"
        (selected)="onTabSelect(tab.id)"
        (expand)="tabExpand.emit()"
        (closed)="tabClose.emit(tab.id)"
        (pointerenter)="onTabHover(tab.id)"
        (pointerleave)="onTabHover(null)"
      />
    }
  </div>
  @if (!popoutMode() && !addDisabled()) {
    <button
      #addButton
      type="button"
      class="eventq-browser-tab-bar__add"
      aria-label="Add tab"
      (click)="tabAdd.emit()"
    >
      <mat-icon>add</mat-icon>
    </button>
  }
</div>
